import React, { useState, useEffect } from "react";

import {
    Spinner
} from "reactstrap";
const TradeData = ({ ...props }) => {
    const [totall, settotall] = useState([])
    const [dataa, setdataa] = useState([])
    const [load, setload] = useState(true)
    const getdata = async () => {
        const sendData = {
            ParametersId: Number(props.parametersId),
            UserId: Number(props.UserId),
            ToYearId: Number(props.toyear),
            ToMonthId: Number(props.tomonth),
            YearId: Number(props.year),
            MonthId: Number(props.Month)
        }

        await fetch(process.env.REACT_APP_API_LINK+'api/NCSCDA/Report', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    if (data.length > 0) {
                        setdataa(data[0])
                    } else {
                        setdataa([])
                    }
                setload(false)
                })

    };
    
    useEffect(() => {
        setload(true)
        getdata()
    }, [props.parametersId, props.UserId, props.generate])

    
  
    return (
        <>
            {load ? <Spinner color="success" /> : 
              <>

                <td style={{ textAlign: 'center', border: '1px solid black', padding: 10 }} >
                        <label> {dataa.apikey1 === "nodata" ?"-" : (dataa.genderMale4 >= 0 ? dataa.genderMale4:0) }</label>

                    </td>
                    
            
                
             

                    </>
           
        }</>
    );
};

export default TradeData;
